var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 256 208",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.624 35.012v87.53l15.058-8.471V43.482l-15.058-8.47z",
    fill: "#949494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.565 114.07V8.66l89.411 50.823v17.883L15.624 35.012v87.53L.564 114.07z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.27 8.659V114.07l-60.235 33.882-15.059-9.412 60.236-33.882V34.07L89.976 77.365V59.482L181.271 8.66z",
    fill: "#949494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.212.188L90.918 42.541 15.624.188.564 8.658l89.412 50.824L181.271 8.66 166.21.189z",
    fill: "#D6D6D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.153 42.541v53.647l15.059 8.47V34.072l-15.06 8.47z",
    fill: "#EFEFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.859 138.541l75.294-42.353 15.059 8.47-60.236 33.883 59.295 33.883 60.235-33.883 15.059 8.47-75.294 42.354-89.412-50.824z",
    fill: "#D6D6D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.859 138.541v17.883l89.412 50.823v-17.882L75.859 138.54zM240.565 147.012V94.306l-15.06-8.47v52.705l15.06 8.47z",
    fill: "#EFEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.27 189.365l75.295-42.353V94.306l15.059-8.47v70.588l-90.353 50.823v-17.882z",
    fill: "#949494"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.624 85.835l-15.06 8.47-15.058-8.47 15.059-8.47 15.059 8.47z",
    fill: "#D6D6D6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M240.565 77.365V59.482l15.059-8.47v17.882l-15.06 8.47z",
    fill: "#949494"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M240.565 59.482v17.883l-15.06-8.47V51.011l15.06 8.47z",
    fill: "#EFEFEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.624 51.012l-15.06 8.47-15.058-8.47 15.059-8.47 15.059 8.47z",
    fill: "#D6D6D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialUi);
export default __webpack_public_path__ + "static/media/material-ui.1830557a7263b60e72c449b47b420c40.svg";
export { ForwardRef as ReactComponent };